import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import { bindActionCreators } from "redux";
import { Check, Error } from "@material-ui/icons";
import DocumentUpload from "./DocumentUpload";
import { images } from "../../utils/images";

function DocumentCentre(props) {
  const { t, classes, account, changeTab } = props;
  const [docType, setDocType] = useState(null);

  if (account.account && account.account.profile === null) {
    return (
      <div className={classes.profileContainer}>
        <div className="upgrade">
          <Error />
          <p>{t("upgradeMessage")}</p>
          <button className="upgradeBtn" onClick={() => changeTab("accType")}>
            {t("upgradeAcc").toUpperCase()}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.documentCentreContainer}>
      <div className="leftSide">
        <p
          className="information"
          dangerouslySetInnerHTML={{ __html: t("docInfo") }}
        />
        <label>{t("selectDocumentType")}</label>
        <div
          className={`docTypeSingle ${docType === "id" ? "activeType" : ""}`}
          onClick={() => setDocType("id")}
        >
          <div className="check">
            <Check />
          </div>
          <p>{t("id")}</p>
          {docType === "id" ? (
            <img src={images.icons.id_card_white} />
          ) : (
            <img src={images.icons.id_card_white} />
          )}
        </div>

        <div
          className={`docTypeSingle ${
            docType === "selfie" ? "activeType" : ""
          }`}
          onClick={() => setDocType("selfie")}
        >
          <div className="check">
            <Check />
          </div>
          <p>{t("selfie")}</p>
          {docType === "selfie" ? (
            <img src={images.icons.selfie_white} />
          ) : (
            <img src={images.icons.selfie_white} />
          )}
        </div>
        <div
          className={`docTypeSingle ${docType === "poa" ? "activeType" : ""}`}
          onClick={() => setDocType("poa")}
        >
          <div className="check">
            <Check />
          </div>
          <p>{t("proofOfAddress")}</p>
          {docType === "poa" ? (
            <img src={images.icons.poa_white} />
          ) : (
            <img src={images.icons.poa_white} />
          )}
        </div>
      </div>
      <div className="rightSide">
        <DocumentUpload documentType={docType} />
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    account: state.account,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

const styles = (theme) => ({
  profileContainer: {
    width: "100%",
    maxWidth: 1100,
    background: theme.colors.background.fore,
    padding: "24px 40px",
    borderRadius: 4,
    boxShadow: theme.defaults.shadow,
    "& .upgrade": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: 400,
      "& svg": {
        color: theme.colors.buttons.sell,
        fontSize: 32,
      },
      "& button": theme.defaults.roundBtn,
      "& p": {
        width: 280,
        margin: "16px auto",
        fontSize: 18,
        // fontFamily: "Titillium Web",
        fontWeight: 600,
        lineHeight: "27px",
        textAlign: "center",
      },
      "& .upgradeBtn": {
        background: "none",
        border: `1px solid ${theme.colors.buttons.green}`,
        color: theme.colors.buttons.green,
        fontSize: 14,
        width: 230,
        color: theme.colors.buttons.green,
      },
    },
  },
  documentCentreContainer: {
    display: "flex",
    justifyContent: "space-between",
    maxWidth: 1320,
    // fontFamily: "Titillium Web",
    width: "100%",

    "& .leftSide": {
      width: "33%",
      padding: 24,
      background: theme.colors.background.fore,
      borderRadius: 2,
      boxShadow: theme.defaults.shadow,

      "& .information": {
        fontSize: 16,
        lineHeight: "24px",
        marginBottom: 24,
        "& a": {
          ...theme.defaults.link,
        },
      },
      "& label": {
        fontSize: 14,
      },
      "& .docTypeSingle": {
        height: 95,
        width: "100%",
        display: "flex",
        alignItems: "center",
        background: theme.colors.background.lightFore,
        borderRadius: 4,
        paddingLeft: 24,
        marginTop: 8,
        paddingRight: 24,
        paddingLeft: 12,
        "& img": {
          width: "auto",
          height: 55,
          marginLeft: "auto",
        },

        "& .check": {
          borderRadius: "50%",
          // border: `1px solid ${theme.colors.text.secondary}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: 24,

          "& svg": {
            color: "transparent",
          },
        },

        "&.activeType": {
          background: theme.colors.misc.activeDoc,
          color: theme.colors.text.textOnRed,
          "& .check": {
            background: theme.colors.text.textOnRed,
            "& svg": {
              color: theme.colors.misc.activeDoc,
            },
          },
        },
      },
    },
    "& .rightSide": {
      width: "65%",
      background: theme.colors.background.fore,
      boxShadow: theme.defaults.shadow,
    },
    [theme.breakpoints.down(790)]: {
      flexDirection: "column",
      "& .leftSide": {
        width: "100%",
        marginBottom: 8,
      },
      "& .rightSide": {
        width: "100%",
      },
    },
  },
});

export default withStyles(styles)(
  withTranslation()(
    connect(mapStateToProps, mapDispatchToProps)(DocumentCentre)
  )
);
